
import Convertshape from "../../../assets/duotone/Convertshape.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ConvertshapeIcon({ className, dataTestid = "ConvertshapeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Convertshape data-testid={dataTestid} className={classes} {...rest} />
  );
}
